import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { getPatient } from "~/api/patients";
import { PageWrapper } from "~/components";
import AutomaticRecording from "~/components/Patient/AutomaticRecording/AutomaticRecording";
import { Health } from "~/components/Patient/Health";
import { NextTest } from "~/components/Patient/NextTest";
import { PatientPersonalInformation } from "~/components/Patient/PatientPersonalInformation";
import { Performance } from "~/components/Patient/Performance";
import { PreparationScaleChart } from "~/components/Patient/PreparationScaleChart";

export const PatientDetail = () => {
  const { id } = useParams();

  const { data: patientData } = useQuery({
    queryFn: () => getPatient(Number(id)),
    queryKey: ["getPatient", { id: Number(id) }],
    enabled: !!id,
  });

  const lastPFA = patientData?.data.last_physical_fitness_assessment_test;

  return (
    <PageWrapper>
      {patientData && (
        <div className="container mx-auto min-h-screen gap-10 p-4">
          <div className="flex flex-wrap justify-between">
            <PatientPersonalInformation patient={patientData.data} />
            {lastPFA && (
              <PreparationScaleChart
                percentage={lastPFA.total_score}
                status={lastPFA.status}
              />
            )}
            {patientData.data.next_test_date && (
              <NextTest date={patientData.data.next_test_date} />
            )}
          </div>
          <AutomaticRecording
            insoleId={patientData.data.active_insole?.id ?? 0}
            patientId={patientData.data.id}
            settings={
              patientData.data.active_insole?.settings ?? {
                auto_record: "off",
                synced: false,
                last_synced_at: null,
              }
            }
          />
          {lastPFA && <Performance lastPFA={lastPFA} />}
          <Health patientId={patientData.data.id} />
        </div>
      )}
    </PageWrapper>
  );
};
